<template>
    <div class="dashboard">
        <div class="dashboard-cards">
            <div class="card">
                <h2>Venues</h2>
                <div>{{ venueCount }} Venues</div>
            </div>
            <div class="card">
                <h2>Classes</h2>
                <div>{{ classesCount }} Classes</div>
            </div>
        </div>
        <div class="dashboard-data">
            <h2>Class Schedule</h2>
            <div class="schedule"  :style="`--grid-column-count: ${Object.keys(schedules).length}`">
                <div v-for="(schedule, key) in schedules" :key="key" class="schedule__column">
                    <div class="schedule__column--header">
                        <span>{{ key }}</span>
                    </div>
                    <div v-for="(item, index) in schedule" :key="index"  class="schedule__column--list">
                        <div class="schedule__column--item">
                            <h3>{{ item.event }}</h3>
                            <div>{{ item.frequency }} on a {{ item.day }}</div>
                            <div>{{ item.starts }} - {{ item.ends }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, ref } from 'vue';
import FetchAPI from '../APIs/FetchAPI'

export default {
    name: 'Dashboard',
    setup() {
        const venues = ref([]);
        const classes = ref([]);
        const schedules = ref([]);

        const venueCount = ref(0);
        const classesCount = ref(0);

        onBeforeMount(async () => { 
            venues.value = await FetchAPI.getFetch('/api/venues')
            venueCount.value = venues.value.length
            
            classes.value = await FetchAPI.getFetch('/api/classes')
            classesCount.value = classes.value.total
            
            schedules.value = await FetchAPI.getFetch('/api/schedules')
        });

        return {
            venues,
            venueCount,
            classes,
            classesCount,
            schedules,
        };
    },
}
</script>

<style>

</style>